import { Component } from '@angular/core';
import { SeoService } from '../seo.service';
import { PageTitleService } from 'src/app/services/pagetitle.service';
import { Subscription } from 'rxjs';
import { ConfirmationComponent } from 'src/app/modals/confirmation/confirmation.component';
import { MatDialogRef } from '@angular/material/dialog';
import { TargetService } from 'src/app/sidenav/target.service';
import { SelectionService } from 'src/app/services/selection.service';
import { OrderConfirmedComponent } from '../modals/order-confirmed/order-confirmed.component';
import { SessionService } from 'src/app/authentication/session.service';
import { Router } from '@angular/router';
import { CoreTargetService } from 'src/app/core/services/target.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { whiteLabelTarget } from 'src/app/utils/whiteLabel';

declare const behamics: any;

@Component({
  selector: 'app-billing-fullscreen',
  templateUrl: './billing-fullscreen.component.html',
  styleUrls: [
    './billing-fullscreen.component.css',
    '../billing/billing.component.css',
    '../../session/organic/signup-premium/signup-premium.component.css',
    '../../session/organic/signup/signup.component.css',
    '../../session/login/login.component.css',
    '../../session/organic/login/login.component.css',
  ],
})
export class BillingFullscreenComponent {
  constructor(
    private selectorService: SelectionService,
    private targetList: TargetService,
    private seoService: SeoService,
    private pageTitle: PageTitleService,
    private sessionService: SessionService,
    public router: Router,
    private coreTargetService: CoreTargetService,
    private localStorageService: LocalStorageService,
  ) {}
  billingSub: Subscription = new Subscription();
  confirmDialogRef: MatDialogRef<ConfirmationComponent>;
  orderConfirmed: MatDialogRef<OrderConfirmedComponent>;

  seoSubscription: any;

  selectedProject: any = {};
  selectedProjectURL: any = '';
  selectedProjectDomain: any = '';
  invoiceList: any = [];
  isLoading: boolean = false;
  firstLoad: boolean = false;

  selectedTabIndex = 0;
  selectedFilterButton: any = 'monthly';
  subscriptionInterval: any;

  currency: string = 'USD';

  features: any = [];
  yearlyPackageSavingPercentage: number = 0.2;
  memberships: any[];

  planClicked: boolean = false;
  isSubscribed: boolean = false;
  subscriptionPlan: any;
  plansLoaded: boolean = false;

  stripeCustomer: any = {};
  cancelAtPeriodEnd: boolean = false;
  selectedSubsription: string;

  customerId: string | null = null;

  showIntervalSwitcher: boolean = false;

  selectedTarget: any;

  isFullScreenBilling: boolean = false;
  isGermanVersion: boolean = true;

  saveAnuallyNumber: number = 180;

  stripeConfig: any;

  whiteLabelTarget = whiteLabelTarget;
  ngOnInit(): void {
    this.pageTitle.setTitle('Billing');

    const email: string = this.localStorageService.get('email') || '';

    this.firstLoad = true;
    this.billingSub.add(
      this.selectorService.currentMessage.subscribe((message: any) => {
        this.selectedTarget =
          this.coreTargetService.getSelectedTarget('target');
        this.billingSub.add(
          this.targetList.getCurrentUserRoles(email).subscribe({
            next: (res) => {
              this.firstLoad = false;
              this.stripeConfig = res?.stripeConfig;

              if (this.stripeConfig) {
                if (!this.stripeConfig.displayPackages) {
                  this.stripeConfig.packages = [
                    this.stripeConfig?.packages?.find((p: any) => p.isActive),
                  ];
                }

                if (!this.stripeConfig.packages?.[0]) {
                  this.stripeConfig['packages'] = [
                    {
                      isActive: this.stripeConfig?.isActive,
                      keywords: this.stripeConfig?.organicKeywordsNum,
                      name: '',
                      price: this.stripeConfig?.priceAmount,
                      stripeSubscription: this.stripeConfig?.stripeSubscription,
                    },
                  ];
                }

                this.stripeConfig?.packages?.forEach((p: any) => {
                  p['features'] = [
                    'Unlimited number of users',
                    'Optimize up to <b>' + p?.keywords + ' keywords</b>',
                    'AI editor',
                    'Advanced audit',
                    'Ranking insights',
                    'Backlink Analysis',
                  ];
                });
              }
            },
            error: (err) => {
              console.log(err);
            },
          }),
        );
      }),
    );
  }

  getSignupCountryVersion(): void {
    const windowUrl: string =
      this.localStorageService.get('signup_organic_url') || '';

    if (windowUrl?.startsWith('/signup_organic_premium_1')) {
      this.isGermanVersion = true;
    }
  }

  pushAdsData() {
    if (
      this.localStorageService.get('gclid_from_web') ||
      this.localStorageService.get('fbclid_from_web')
    ) {
      const data = {
        event_type: 'organic_cr',
        email: this.localStorageService.get('email'),
      };

      this.sessionService.pushAdsData(data).subscribe((res) => {});
    }
  }

  ngOnDestroy() {
    this.billingSub?.unsubscribe();
  }

  processingAPI: boolean = false;
  createSubscription(p: any) {
    const params: any = {
      package: p?.name,
      organicKeywordsNum: p?.keywords,
      priceId:
        this.stripeConfig?.['stripePrices']?.[p?.name] ||
        this.stripeConfig?.priceId,
      packageId: p.id,
      target: this.coreTargetService.getSelectedTarget('target'),
      forOrganic: true,
    };

    this.processingAPI = true;
    this.billingSub.add(
      this.seoService.getStripeCustomCreateSubscription(params).subscribe({
        next: (res) => {
          this.processingAPI = false;
          this.planClicked = false;
          if (res?.url) {
            window.open(res.url, '_self');
          }
        },
        error: (err) => {
          console.log(err);
          this.processingAPI = false;
          this.planClicked = false;
        },
      }),
    );
  }

  logout() {
    this.sessionService.logout();
  }
}
